import { Box, useTheme, Skeleton } from "@mui/material"

export const PromotionDetailSidebarSkeleton = ({ Layout = Box }) => {
  const theme = useTheme()
  const {
    locationButton,
    titleText,
    descriptionText,
    qrCode,
    detailContainer,
    infoListItem,
    locationButtonContainer,
    infoContainer,
    listItemContainer,
    qrcodeText,
  } = theme.components[`SkeletonPromotionDetail`]?.styleOverrides || {}

  return (
    <Box sx={detailContainer}>
      <Skeleton variant="text" sx={titleText} />
      <Skeleton variant="rectangular" sx={descriptionText} />
      <Box sx={infoContainer}>
        <Box>
          <Skeleton variant="rectangular" sx={qrCode} />
          <Skeleton variant="text" sx={qrcodeText} />
        </Box>
        <Box sx={listItemContainer}>
          <Skeleton variant="rectangular" sx={infoListItem} />
          <Skeleton variant="rectangular" sx={infoListItem} />
        </Box>
      </Box>
      <Box sx={locationButtonContainer}>
        <Skeleton variant="rectangular" sx={locationButton} />
      </Box>
    </Box>
  )
}
